// extracted by mini-css-extract-plugin
export default {"table":"Table_table__k1nJ7","hiddenHeader":"Table_hiddenHeader__UzwYy"};